import React from "react";
import Layout from "../../layout";
import RiskmapTable from "../../components/tables/riskmap";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Box, Typography } from "@mui/material";

const AdminRiskmapPage = () => {
    return (
        <Layout pageTitle="Riskmap" parentUrl="" parentPageName="">
            <Grid item xs={6}>
                <Card>
                    <Box sx={{ mt: 0.2, textAlign: "end", backgroundColor: "grey.100" }}>
                        <Typography sx={{ padding: "1rem", fontWeight: 700 }}>
                            Riskmap
                        </Typography>
                    </Box>
                    <RiskmapTable />
                </Card>
            </Grid>
        </Layout>
    );
};

export default AdminRiskmapPage;
